import * as S from './Info.styles';

type InfoProps = {
  isImportant?: boolean;
  message: string;
};

const defaultProps: Partial<InfoProps> = {
  isImportant: false,
};

export function Info(props: InfoProps): React.ReactElement {
  const { message, isImportant } = { ...defaultProps, ...props };

  return (
    <S.Container>
      <S.InfoIcon name="FiInfo" />

      {isImportant ? (
        <S.Important fontWeight="bold" scale="lg" color="colmarBlue">
          Important!
        </S.Important>
      ) : null}

      <S.Message scale="lg" color="colmarBlue">
        {message}
      </S.Message>
    </S.Container>
  );
}
